{
  "schema_id": "sequesign.policy_checked.v0.1",
  "type": "object",
  "required": ["policy_version", "auto_pay_limit_usd", "invoice_amount_usd", "decision", "reason"],
  "properties": {
    "policy_version": {
      "type": "string"
    },
    "auto_pay_limit_usd": {
      "type": "number",
      "minimum": 0
    },
    "invoice_amount_usd": {
      "type": "number",
      "minimum": 0
    },
    "decision": {
      "type": "string",
      "enum": ["approved", "requires_human_approval", "rejected"]
    },
    "reason": {
      "type": "string"
    }
  },
  "additionalProperties": false
}
